module.exports = "<div class=\"error-message\" *ngIf=\"errorMessage !== null\">{{errorMessage}}</div>\r\n"